import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";

import "@/components/membership/Dashboard/Dashboard.css";

function UnstageFileModal({ open, setOpenUnstageModal, unstageFile }) {
  const [reason, setReason] = useState("bad_data");

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleClose = () => {
    setOpenUnstageModal(false);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Are You Sure?</DialogTitle>
        <DialogContent sx={{ paddingTop: "20px !important" }}>
          <Typography>
            This file will be removed from the queue and this data won&apos;t be
            sent to VAN.
          </Typography>
          <Divider sx={{ margin: "13px 0" }} />
          <FormControl>
            <Typography>Reason:</Typography>
            <RadioGroup defaultValue={reason} onChange={handleReasonChange}>
              <FormControlLabel
                value="bad_data"
                control={<Radio />}
                label="Bad Data File"
              />
              <FormControlLabel
                value="other"
                control={<Radio />}
                label="Other"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button className="siteRed" onClick={() => unstageFile(reason)}>
            Do not send file to VAN
          </Button>
          <Button className="siteBlueOutlined" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default UnstageFileModal;
